import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ZefErrorsState, ZefErrorHandlerType } from './errors.model';
import { FEATURE_NAME } from './errors.constant';
import { ZefKeyInput, filterByKeyInput } from '@zerops/zef/core';

export const selectZefErrorsState = createFeatureSelector<ZefErrorsState>(FEATURE_NAME);

export const selectZefErrors = createSelector(
  selectZefErrorsState,
  (state) => state.errors
);

export const selectZefErrorByTypeAndId = (key: string, id: string) => createSelector(
  selectZefErrors,
  (state) => state.find((p) => p.key === key && id === id)
);

export const selectZefErrorByTypeAndTag = (key: string, tag: string) => createSelector(
  selectZefErrors,
  (state) => state.find((p) => p.key === key && tag === p.tag)
);

export const selectZefErrorByType = (key: string) => createSelector(
  selectZefErrors,
  (state) => state.find((p) => p.key === key)
);

export const selectZefErrorByErrorType = (type: ZefErrorHandlerType) => createSelector(
  selectZefErrors,
  (state) => state.filter((p) => p.errorType === type)
);

export const selectZefErrorsByType = (keyInput: ZefKeyInput) => createSelector(
  selectZefErrors,
  (state) => filterByKeyInput(state, keyInput)
);

export const selectZefErrorMapByType = (keyInput: ZefKeyInput) => createSelector(
  selectZefErrors,
  (state) => filterByKeyInput(state, keyInput)
    .filter((p) => !!p.id)
    .reduce((obj, p) => {
      if (!obj[p.id]) {
        obj[p.id] = {};
      }

      obj[p.id][p.key] = p;

      return obj;
    }, {})
);
